import React, {useContext} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {NavItem, NavLink, UncontrolledTooltip} from 'reactstrap';
import AppContext from '../../context/Context';

const ThemeToggle = () => {
    const {isDark, setIsDark} = useContext(AppContext);
    const label = isDark ? 'Activar modo claro' : 'Activar modo noche';

    const handleClick = event => {
        event.preventDefault();
        setIsDark(!isDark);
    };

    return (
        <NavItem>
            <NavLink
                href="#!"
                id="themeToggle"
                className="px-2"
                onClick={handleClick}
                aria-label={label}
                aria-pressed={isDark}
                title={label}
            >
                <FontAwesomeIcon icon={isDark ? 'sun' : 'moon'} className="fs-0"/>
            </NavLink>
            <UncontrolledTooltip placement="bottom" target="themeToggle">
                {label}
            </UncontrolledTooltip>
        </NavItem>
    );
};

export default ThemeToggle;
